import "./App.scss";
import { useSelector } from "react-redux";
import { authAction, selectAuth, selectUser, setAuth } from "./core/auth/authSlice";

import PublicRoute from "./core/routes/PublicRoute";
import { useEffect } from "react";
import { useAppDispatch } from "./app/hooks";
import AuthRoute from "./core/routes/AuthRoute";
import ErrorManagement from "./core/errors/ErrorManagement";
import LoadingOverlay from "./components/essentials/loading-overlay/LoadingOverlay";
import { selectLoading, selectLoadingMessage } from "./core/loading/loadingSlice";
import { LanguageProvider } from "./shared/i18n";



function App() {
  const auth = useSelector(selectAuth)
  const user = useSelector(selectUser)
  const isLoading = useSelector(selectLoading)
  const loadingMessage = useSelector(selectLoadingMessage)
  const dispatch = useAppDispatch()

  useEffect(() => {
    // Try to authenticate with the HTTP-only cookie (silent = true to suppress error toasts)
    dispatch(authAction(undefined, true))
  }, [dispatch])

  return (
    <LanguageProvider userPreferredLanguage={user?.preferredLanguage}>
      <div className="App">
        <ErrorManagement />
        {isLoading && <LoadingOverlay message={loadingMessage} />}
        {auth === undefined ? <LoadingOverlay /> : (
          auth ? <AuthRoute /> : <PublicRoute />
        )}
      </div>
    </LanguageProvider>
  );
}

export default App;
